import { Navigate } from "react-router-dom";
import { useAuthentication } from "../contexts/AuthenticationContext";

export function NonAuthenticatedGuard({ children }: { children: JSX.Element }) {
  const [{ isAuthenticated }] = useAuthentication();

  if (isAuthenticated) {
    const redirectTo = sessionStorage.getItem("__redirect_after_login__") || "/member";
    sessionStorage.removeItem("__redirect_after_login__");

    return <Navigate to={redirectTo} replace />;
  }


  return children;
}
